//export const walletTestConnectId = "https://data-seed-prebsc-1-s1.binance.org:8545/";
export const walletTestConnectId = "https://bsc-dataseed.binance.org/";
//export const walletMainConnectId = "https://bsc-dataseed.binance.org/";
export const walletMainConnectId = "https://bsc-dataseed.binance.org/";
export const networkTestChainId = '97';
export const networkMainChainId = '56';


export const WalletTypes = {
    default: 0,
    metamask: 1,
    binance: 2,
    walletConnect: 3,
};

export const Networks = {
    mainnet: "0x1",
    ropsten: "0x3",
    rinkeby: "0x4",
    goerli: "0x5",
    kovan: "0x2a",
    moonBaseAlpha: "0x507",
};
